import lazyLoad from "./lazyLoad";
import SmoothScroll from 'smooth-scroll';
import setNav from "./setnav";
import ScrollHint from "scroll-hint";
import ToggleClass from "./toggleClass";
import LocalNav from "./localNav";
import Rooms from "./rooms";
import ShowLayout from "./showLayout";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import ModalFx from "bulma-modal-fx/dist/js/modal-fx";
import "bulma-modal-fx/dist/css/modal-fx.css";

const init = () => {
	const scroll = new SmoothScroll('a[href*="#"]', {
		speed: 300,
		easing: 'easeOutQuint',
		header: '[data-scroll-header]'
	});
	setNav();
	lazyLoad();
	LocalNav();

	cf7redirect();
	new ScrollHint('.js-scrollable');

	const faqDt = document.querySelectorAll(".faq_list dt");
	ToggleClass(faqDt, "show");

	const loop = () => {
		//back to top
		const vscroll = document.documentElement.scrollTop;
		const gotop = document.querySelector(".gotop");
		if (gotop !== null) {
			if (vscroll >= 800) {
				gotop.classList.add("show");
			} else {
				gotop.classList.remove("show");
			}
		}
		//header
		const header = document.querySelector("[data-scroll-header]");
		const headerHeight = header.clientHeight;
		if (header !== null) {
			if (headerHeight <= window.scrollY) {
				header.classList.add("_small");
			} else {
				header.classList.remove("_small");
			}
		}
		const nav_floating = document.querySelector(".property_header_floating");
		if (nav_floating !== null) {
			if (window.scrollY >= 400) {
				nav_floating.classList.add("_show");
			} else {
				nav_floating.classList.remove("_show");
			}
		}
		window.requestAnimationFrame(loop);
	}
	loop();

	//swiper
	// const swiper_thumb = new Swiper(".property_gallery_thumbs", {
	// 	spaceBetween: 10,
	// 	slidesPerView: 4,
	// 	freeMode: true,
	// 	watchSlidesProgress: true,
	// });
	const gallery1 = new Swiper("#gallery1", {
		spaceBetween: 10,
		loop: true,
		navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev",
		},
	});
	const thumbs1 = document.querySelectorAll("#thumbs1 .property_gallery_thumbs_item");
	thumbs1.forEach(el => {
		el.addEventListener("click", function() {
			const index = this.dataset.index;
			gallery1.slideTo(index);
		});
	});

	const gallery2 = new Swiper("#gallery2", {
		spaceBetween: 10,
		loop: true,
		navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev",
		},
	});
	const thumbs2 = document.querySelectorAll("#thumbs2 .property_gallery_thumbs_item");
	thumbs2.forEach(el => {
		el.addEventListener("click", function() {
			const index = this.dataset.index;
			gallery2.slideTo(index);
		});
	});

	const mainphoto = new Swiper("#mainphoto", {
		spaceBetween: 10,
		effect: 'fade',
		speed: 2000,
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 4000,
		},
	});

	Rooms();
}

//init
if (document.readyState !== "loading") {
	init();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		init();
	})
}
	
//Contact Form 7
const cf7redirect = () => {
	document.addEventListener('wpcf7mailsent', function (event) {
		const protocol = window.location.protocol;
		const host = window.location.host;
		let path = "contact-thanks";
		location = `${protocol}//${host}/${path}/`;
	}, false);
}